import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { isEmpty } from 'lodash';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { routes } from 'src/routes';
import { ReportTemplateService } from 'src/services';
import { ReportTemplateCacheService } from 'src/services/report-template-cache.service';

@Injectable({
  providedIn: 'root',
})
export class EditRedirectGuard {
  private readonly router = inject(Router);
  private readonly reportTemplateCacheService = inject(ReportTemplateCacheService);
  private readonly reportTemplateService = inject(ReportTemplateService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const reportTemplate = this.reportTemplateCacheService.load();

    const preventRedirect = next.queryParams['preventRedirect'];
    // If we have a report template in our cache redirect to the editor (only if a )
    if (reportTemplate && isEmpty(preventRedirect)) {
      // If the report template has an ID, check if it still exists before redirecting to the editor
      return of(reportTemplate.id).pipe(
        switchMap((id) => (isEmpty(id) ? of(true) : this.reportTemplateService.exists(id))),
        switchMap((canRedirect) =>
          canRedirect
            ? this.router.navigate([`${routes.edit.url}/template`, reportTemplate.id || ''])
            : this.router.navigate([`${routes.edit.url}/templates`], {
                queryParams: { preventRedirect: true },
              })
        )
      );
    }

    return true;
  }
}
